import React from 'react'
import PropTypes from 'prop-types'
import Loading from '../../../../molecules/Loading'
import FlexRow from '../../../../molecules/FlexRow'
import FadeIn from '../../../../molecules/Transitions/FadeIn'
import usePlanStatusReport from './hooks/usePlanStatusReport'
import PlanBoard from './PlanBoard'

const MIN_HEIGHT = '300px'

const messageRowStyle = {
  minHeight: MIN_HEIGHT,
  fontSize: 'var(--font-size-xs)'
}

function SalesforceStatusReportInner ({ config, displayName }) {
  const { plan, notLinked, isLoading, error } = usePlanStatusReport()

  if (isLoading) {
    return (
      <div style={{ minHeight: MIN_HEIGHT }}>
        <Loading />
      </div>
    )
  }

  if (error) {
    return (
      <FadeIn>
        <FlexRow
          className='justify-center items-center'
          style={{ ...messageRowStyle, color: 'var(--color-decline-500)' }}
        >
          Failed to load plan status report
        </FlexRow>
      </FadeIn>
    )
  }

  if (notLinked) {
    return (
      <FadeIn>
        <FlexRow
          className='justify-center items-center'
          style={{ ...messageRowStyle, color: 'var(--text-color-subtle)' }}
        >
          Plan status report is not available for this client
        </FlexRow>
      </FadeIn>
    )
  }

  if (!plan) {
    return (
      <FadeIn>
        <FlexRow
          className='justify-center items-center'
          style={{ ...messageRowStyle, color: 'var(--text-color-subtle)' }}
        >
          No plan available
        </FlexRow>
      </FadeIn>
    )
  }

  return (
    <FadeIn>
      <PlanBoard plan={plan} config={config} displayName={displayName} />
    </FadeIn>
  )
}

SalesforceStatusReportInner.propTypes = {
  config: PropTypes.object,
  displayName: PropTypes.string
}

export default SalesforceStatusReportInner
